export default "__VITE_ASSET__BdFqH3Yw__"